import { SliderItem as SliderItemCore } from '@studiometa/ui';
import { matrix } from '@studiometa/js-toolkit/utils';

/**
 * @typedef {object} SliderItemRef
 * @property {HTMLImageElement} img
 * @property {HTMLElement} title
 * @property {HTMLElement} titleInner
 * @property {HTMLElement} surtitle
 */

/**
 * @typedef {object} SliderItemInterface
 * @property {SliderItemRef} $refs
 */

/**
 * SliderItem class
 */
export default class SliderItem extends SliderItemCore {
  static config = {
    ...SliderItemCore.config,
    name: 'SliderItem',
    emits: ['clicked'],
    refs: ['img', 'title', 'surtitle', 'centered'],
    options: {
      ...SliderItemCore.config.options,
      slug: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * Emit the clicked event on click
   * @param   {Event} event
   * @this    {SliderItem & SliderItemInterface}
   * @returns {void}
   */
  onTitleClick(event) {
    event.preventDefault();
    this.$emit('clicked', this);
  }

  /**
   * Render function
   * @this    {SliderItem & SliderItemInterface}
   * @returns {void}
   */
  render() {
    super.render();
    const x = this.rect.x - this.$parent.getOriginByMode() + this.dampedX;
    this.$refs.centered.style.transform = matrix({ translateX: x });
  }
}
